import {
  CreativeManager,
  DefaultCreativeManager,
} from 'core/creative/CreativeManager';
import { L1ObjectChannel } from 'core/l1Object/L1Object';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { useCampaignStore } from 'store/campaignStore';
import useCreativeStore from 'store/creativeStore';
import { useOrderStore } from 'store/orderStore';

interface CreativeFormProps {}

const creativeManager: CreativeManager = new DefaultCreativeManager();

const useCreativeForm = (initialState: CreativeFormProps = {}) => {
  const { order } = useOrderStore();
  const { adType, handleLoading } = useCampaignStore();
  const { creatives, handleAddCreatives, handleChangeCreative } =
    useCreativeStore();

  const getCreativesByCampaignId = async (campaignId: string) => {
    try {
      if (campaignId) {
        const creatives = await creativeManager.getCreativesByCampaignId(
          campaignId,
          false,
        );
        if (adType === AdType.SHOP) {
          handleAddCreatives(
            creatives.map((creative) => ({
              name: creative.name,
              id: creative.id,
              creativeType: creative.creativeType,
              brandName: creative.creativeValue.brandName,
              webBrandNo: creative.creativeValue.webBrandNo,
              categoryCode: creative.creativeValue.categoryCode,
              categoryName: creative.creativeValue.categoryName,
              bannerUrl: creative.creativeValue.bannerUrl,
              productName: creative.creativeValue.productName,
              productId: creative.creativeValue.productId,
              bindingState: creative.bindingState,
            })),
          );
        } else {
          handleAddCreatives(creatives);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getWaitingBindCreatives = async (adType: string) => {
    handleLoading(true);
    try {
      const allCreatives = await creativeManager.getWaitingBindCreatives({
        channel: L1ObjectChannel.RTB,
        advertiserId: order.advertiserId,
        adType: adType,
      });
      const filteredCreatives = allCreatives.filter(
        (creative) => !creatives.some((c) => c.id === creative.id),
      );
      return filteredCreatives;
    } catch (e) {
      console.error(e);
    } finally {
      handleLoading(false);
    }
  };

  // 透過 creative.id 取得該筆素材資料
  const getCreative = async (id: number) => {
    if (!id) return;

    handleLoading(true);
    const newCreative = await creativeManager.getCreative(id);

    if (newCreative?.basic) {
      newCreative.basic.creativeValues = JSON.parse(
        newCreative.basic.creativeValues,
      );
      handleChangeCreative({
        ...newCreative.basic,
        updateImg: false, // 只有上傳圖片的當下會設成 true, 用意是檢查檔案大小
      });
    }
    handleLoading(false);
    // console.log('現在的 creative ===> ', creative)
  };

  return { getCreativesByCampaignId, getWaitingBindCreatives, getCreative };
};

export default useCreativeForm;
